import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const login = r => require.ensure([], () => r(require('@/page/login')), 'login');
const manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage');
const home = r => require.ensure([], () => r(require('@/page/home')), 'home');
const userList = r => require.ensure([], () => r(require('@/page/user/userList')), 'userList');
const userApprove = r => require.ensure([], () => r(require('@/page/user/userApprove')), 'userApprove');
const addUser = r => require.ensure([], () => r(require('@/page/user/addUser')), 'addUser');
const projectReportList = r => require.ensure([], () => r(require('@/page/project/projectReportList')), 'projectReportList');
const personalProjectList = r => require.ensure([], () => r(require('@/page/project/personalProjectList')), 'personalProjectList');

const addProjectReport = r => require.ensure([], () => r(require('@/page/project/addProjectReport')), 'addProjectReport');
const projectApprove = r => require.ensure([], () => r(require('@/page/project/projectApprove')), 'projectApprove');
const techApplyList = r => require.ensure([], () => r(require('@/page/supportApply/techApplyList')), 'techApplyList');
const addTechApply = r => require.ensure([], () => r(require('@/page/supportApply/addTechApply')), 'addTechApply');
const techApplyApprove = r => require.ensure([], () => r(require('@/page/supportApply/techApplyApprove')), 'techApplyApprove');
const queryTechApply = r => require.ensure([], () => r(require('@/page/supportApply/queryTechApply')), 'queryTechApply');


const businessApplyList = r => require.ensure([], () => r(require('@/page/supportApply/businessApplyList')), 'businessApplyList');
const addBusinessApply = r => require.ensure([], () => r(require('@/page/supportApply/addBusinessApply')), 'addBusinessApply');
const businessApplyApprove = r => require.ensure([], () => r(require('@/page/supportApply/businessApplyApprove')), 'businessApplyApprove');
const queryBusinessApply = r => require.ensure([], () => r(require('@/page/supportApply/queryBusinessApply')), 'queryBusinessApply');

const problemFeedback = r => require.ensure([], () => r(require('@/page/problem/problemFeedback')), 'problemFeedback');
const addProblemFeedback = r => require.ensure([], () => r(require('@/page/problem/addProblemFeedback')), 'addProblemFeedback');
const problemFeedbackApprove = r => require.ensure([], () => r(require('@/page/problem/problemFeedbackApprove')), 'problemFeedbackApprove');
const product = r => require.ensure([], () => r(require('@/page/product/product')), 'product');
const checkOrder = r => require.ensure([], () => r(require('@/page/checkOrder/checkOrder')), 'checkOrder');
const checkOrderApprove = r => require.ensure([], () => r(require('@/page/checkOrder/checkOrderApprove')), 'checkOrderApprove');
const addCheckOrder = r => require.ensure([], () => r(require('@/page/checkOrder/addCheckOrder')), 'addCheckOrder');
const queryCheckOrder = r => require.ensure([], () => r(require('@/page/checkOrder/queryCheckOrder')), 'queryCheckOrder');

const projectOrder = r => require.ensure([], () => r(require('@/page/projectOrder/projectOrder')), 'projectOrder');
const queryProjectOrder = r => require.ensure([], () => r(require('@/page/projectOrder/queryProjectOrder')), 'queryProjectOrder');
const addProjectOrder = r => require.ensure([], () => r(require('@/page/projectOrder/addProjectOrder')), 'addProjectOrder');
const projectOrderApprove = r => require.ensure([], () => r(require('@/page/projectOrder/projectOrderApprove')), 'projectOrderApprove');
const material = r => require.ensure([], () => r(require('@/page/material/material')), 'material');


export default new Router({
	mode: 'history', //去除url中的#
	base:  '/channel/',
	routes: [{
		path: '/',
		name: 'login',
		component: login
	}, {

		path: '/manage',
		component: manage,
		name: '',
		children: [
			{
				path: '',
				component: home,
				meta: [],
			},{
			path: '/userList',
			component: userList,
			meta: [],
		}, {
			path: '/queryProjectOrder',
			component: queryProjectOrder,
			meta: [],
		},{
			path: '/queryCheckOrder',
			component: queryCheckOrder,
			meta: [],
		},{
			path: '/userApprove',
			component: userApprove,
			meta: [],
		},  {
			path: '/addUser',
			component: addUser,
			meta: [],
		},{
			path: '/product',
			component: product,
			meta: [],
		},{
			path: '/projectReportList',
			component: projectReportList,
			meta: [],
		},{
			path: '/personalProjectList',
			component: personalProjectList,
			meta: [],
		},{
			path: '/addProjectReport',
			component: addProjectReport,
			meta: [],
		},{
			path: '/projectApprove',
			component: projectApprove,
			meta: [],
		},{
			path: '/addCheckOrder',
			component: addCheckOrder,
			meta: [],
		},
		{
			path: '/checkOrder',
			component: checkOrder,
			meta: [],
		},
		{
			path: '/checkOrderApprove',
			component: checkOrderApprove,
			meta: [],
		},
		
		
		{
			path: '/projectOrder',
			component: projectOrder,
			meta: [],
		},{
			path: '/addProjectOrder',
			component: addProjectOrder,
			meta: [],
		},{
			path: '/projectOrderApprove',
			component: projectOrderApprove,
			meta: [],
		},
		
		
		{
			path: '/techApplyList',
			component: techApplyList,
			meta: [],
		},{
			path: '/addTechApply',
			component: addTechApply,
			meta: [],
		},{
			path: '/techApplyApprove',
			component: techApplyApprove,
			meta: [],
		},{
			path: '/queryTechApply',
			component: queryTechApply,
			meta: [],
		},
		{
			path: '/businessApplyList',
			component: businessApplyList,
			meta: [],
		},{
			path: '/addBusinessApply',
			component: addBusinessApply,
			meta: [],
		},{
			path: '/businessApplyApprove',
			component: businessApplyApprove,
			meta: [],
		},{
			path: '/queryBusinessApply',
			component: queryBusinessApply,
			meta: [],
		},
		
		
		
		{
			path: '/problemFeedback',
			component: problemFeedback,
			meta: [],
		},{
			path: '/problemFeedbackApprove',
			component: problemFeedbackApprove,
			meta: [],
		},{
			path: '/addProblemFeedback',
			component: addProblemFeedback,
			meta: [],
		},{
			path: '/material',
			component: material,
			meta: [],
		}]
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js